import type { Option } from "components/common/utlis/TypeAnnotations";

export const applicationOptions: Option[] = [
  { value: 1, label: "New" },
  { value: 2, label: "Completed" },
];


